import moment from "moment";

export function  formatAmount  (value){
    return `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

export function   formatCreditCardNumber (value) {
    if (!value) return "";

    // Remove non-digit characters from the input
    const digitsOnly = value.toString().replace(/\D/g, "");

    // Split the credit card number into groups of 4 digits
    const groups = [];
    for (let i = 0; i < digitsOnly.length; i += 4) {
      groups.push(digitsOnly.substr(i, 4));
    }

    // Join the groups with a space between each group
    return groups.join("-");
  };

  export function formatdate (date){
   return new moment(date).format('LL')
  }

  export function parseCreditCardNumber  (value) {
    // Remove non-digit characters from the input
    return value.toString().replace(/\D/g, "").slice(0, 16);
  };

  export function formatName(name) {
    if (!name) return "";
    
    // Convert to lowercase first, then split by spaces
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Returns true if the current dealer host has elevated permissions (invite/payments, etc.)
  export function dealerhostHasPermission(currentDealerhost) {
    if (!currentDealerhost) return false;
    const flags = [
      currentDealerhost.is_admin,
      currentDealerhost.is_supervisor,
      currentDealerhost.can_invite,
      currentDealerhost.can_manage_payments,
      currentDealerhost.admin,
      currentDealerhost.supervisor,
      currentDealerhost.isAdmin,
      currentDealerhost.isSupervisor
    ];
    if (flags.some(v => v === true || v === 'Y' || v === '1')) return true;
    const titleOrRole = currentDealerhost.dealer_host_title || currentDealerhost.role;
    if (typeof titleOrRole === 'string') {
      const normalized = titleOrRole.trim().toUpperCase();
      if (normalized === 'ADMINISTRATOR' || normalized === 'SUPERVISOR' || normalized === 'OWNER') return true;
    }
    return false;
  }
